export default __webpack_public_path__ + "static/media/miguel-lopes-28.0e666e22.jpg";